import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import api from 'middlewares/api';
import oldApi from 'containers/App/screens/Tube/utils/oldApi';
import { isJsonString } from 'utils/index';
import promiseMiddleware from 'redux-promise-middleware';
import { Iterable } from 'immutable';
import queryString from 'query-string';
import {
  defaultLocale,
  allowLocales,
} from 'configs/locale.js';
import cookie from 'utils/cookie';
import {
  find,
} from 'lodash';
import axios from 'axios';
import { camelizeKeys, pascalizeKeys } from 'humps';

export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAIL = 'FAIL';

let createStoreWithMiddleware = createStore;

if (process.env.PROJECT_ENV === 'production') {
  createStoreWithMiddleware = applyMiddleware(
    api,
    oldApi,
    thunkMiddleware,
    promiseMiddleware({
      promiseTypeSuffixes: [REQUEST, SUCCESS, FAIL],
    })
  )(createStore);
} else {
  const loggerMiddleware = createLogger({
    stateTransformer: (state) => {
      const newState = {};
      for (const key of Object.keys(state)) {
        if (Iterable.isIterable(state[key])) {
          newState[key] = state[key].toJS();
        } else {
          newState[key] = state[key];
        }
      }
      return newState;
    },
  });

  createStoreWithMiddleware = applyMiddleware(
    api,
    oldApi,
    thunkMiddleware,
    promiseMiddleware({
      promiseTypeSuffixes: [REQUEST, SUCCESS, FAIL],
    }),
    loggerMiddleware
  )(createStore);
}

export const axiosTransform = {
  response: (data, header) => {
    if (header['content-type'] && header['content-type'].indexOf('application/json') > -1) {
      if (isJsonString(data)) {
        return camelizeKeys(JSON.parse(data));
      }
      return camelizeKeys(data);
    }
    return data;
  },
  request: (data) => {
    if ((typeof data) === 'object' && !(data instanceof FormData)) {
      return JSON.stringify(pascalizeKeys(data));
    }
    return data;
  },
};

export default function configureStore(rootReducer, moduleType, baseURL, initialState) {
  const queryStrings = queryString.parse(location.search);
  let locale = (queryStrings.lang && queryStrings.lang !== 'undefined' ? queryStrings.lang : undefined) || sessionStorage.locale ||
                cookie.getValue('PreferenceLanguage') || navigator.language;
  locale = locale ? locale.toLowerCase() : locale;
  if (find(allowLocales, { 'code': locale }) === undefined) {
    locale = defaultLocale;
  }
  sessionStorage.locale = locale;

  // axios 設定
  axios.defaults.baseURL = baseURL;
  axios.defaults.headers.common['Accept-Language'] = locale;
  axios.defaults.withCredentials = true;
  axios.defaults.transformResponse = axiosTransform.response;
  axios.defaults.transformRequest = axiosTransform.request;
  axios.defaults.responseType = 'json';
  axios.defaults.headers.post['Content-Type'] = 'application/json';
  axios.defaults.headers.put['Content-Type'] = 'application/json';
  axios.defaults.headers.delete['Content-Type'] = 'application/json';

  const _isShowOnboardingProcess = localStorage.getItem('isShowOnboardingProcess') ? JSON.parse(localStorage.getItem('isShowOnboardingProcess')) : false;
  let appState = {
    app: {
      application: {
        moduleType,
        isLoading: false,
        isLoaded: false,
        locale,
        RKey: queryStrings.code,
        red: queryStrings.red ? queryStrings.red : location.host + '/Tube',
        accessToken: sessionStorage.access_token,
        employeeId: sessionStorage.employee_id,
        companyId: sessionStorage.company_id,
        isLoggedIn: cookie.isExist('__ModuleSessionCookie2') !== false,
        isOtherAccountLoggedIn: false,
        isShowOnboardingProcess: _isShowOnboardingProcess,
        progresses: [],
        locales: allowLocales,
        headers: {
          'Accept-Language': locale,
        },
        theme: {
          footerColor: '#000',
          footerFontColor: '#ccc',
          headerColor: '#000',
          headerFontColor: '#fff',
          menuFontColor: '#ccc',
          menuHoverFontColor: '#fff',
        },
        logoUrl: null,
        isPreviewMode: queryStrings.ipm === 's',
        functionSetting: {
          datas: [],
          isLoading: false,
        },
      },
    },
  };

  appState = Object.assign(appState, initialState);

  return createStoreWithMiddleware(rootReducer, appState);
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/configureStore.js
 **/